export const COLUMN_HEADERS = [
  { Header: "Survey Source Code", width: 120, accessor: "survey_code" },
  { Header: "Survey Report Short Title", width: 200, accessor: "pub_survey_short_name" },
  { Header: "Survey Job Code", width: 110, accessor: "job_code" },
  { Header: "Survey Job Title", width: 115, accessor: "job_title" },
  { Header: "Survey Data Cut", width: 200, accessor: "job_scope" },
  { Header: "Base Salary # of Companies", width: 175, accessor: "base_salary_cos" },
  { Header: "Base Salary # of Incumbents", width: 175, accessor: "base_salary_ees" },
  { Header: "Base Salary R-sqr", width: 115, accessor: "base_salary_r2" },
  { Header: "Base Salary Intercept", width: 130, accessor: "base_salary_intercept" },
  { Header: "Base Salary Slope", width: 115, accessor: "base_salary_slope" },
  { Header: "Base Salary SEE", width: 100, accessor: "base_salary_see" },
  { Header: "Base Salary 10th", width: 110, accessor: "base_salary_10_formatted" },
  { Header: "Base Salary 25th", width: 110, accessor: "base_salary_25_formatted" },
  { Header: "Base Salary 50th", width: 110, accessor: "base_salary_50_formatted" },
  { Header: "Base Salary 75th", width: 110, accessor: "base_salary_75_formatted" },
  { Header: "Base Salary 90th", width: 110, accessor: "base_salary_90_formatted" },
  { Header: "Total Cash # of Companies", width: 175, accessor: "total_cash_cos" },
  { Header: "Total Cash # of Incumbents", width: 175, accessor: "total_cash_ees" },
  { Header: "Total Cash R-sqr", width: 115, accessor: "total_cash_r2" },
  { Header: "Total Cash Intercept", width: 130, accessor: "total_cash_intercept" },
  { Header: "Total Cash Slope", width: 115, accessor: "total_cash_slope" },
  { Header: "Total Cash SEE", width: 100, accessor: "total_cash_see" },
  { Header: "Total Cash 10th", width: 110, accessor: "total_cash_10_formatted" },
  { Header: "Total Cash 25th", width: 110, accessor: "total_cash_25_formatted" },
  { Header: "Total Cash 50th", width: 110, accessor: "total_cash_50_formatted" },
  { Header: "Total Cash 75th", width: 110, accessor: "total_cash_75_formatted" },
  { Header: "Total Cash 90th", width: 110, accessor: "total_cash_90_formatted" },
  { Header: "Total Direct # of Companies", width: 175, accessor: "total_direct_cos" },
  { Header: "Total Direct # of Incumbents", width: 175, accessor: "total_direct_ees" },
  { Header: "Total Direct R-sqr", width: 115, accessor: "total_direct_r2" },
  { Header: "Total Direct Intercept", width: 130, accessor: "total_direct_intercept" },
  { Header: "Total Direct Slope", width: 115, accessor: "total_direct_slope" },
  { Header: "Total Direct SEE", width: 100, accessor: "total_direct_see" },
  { Header: "Total Direct 10th", width: 110, accessor: "total_direct_10_formatted" },
  { Header: "Total Direct 25th", width: 110, accessor: "total_direct_25_formatted" },
  { Header: "Total Direct 50th", width: 110, accessor: "total_direct_50_formatted" },
  { Header: "Total Direct 75th", width: 110, accessor: "total_direct_75_formatted" },
  { Header: "Total Direct 90th", width: 110, accessor: "total_direct_90_formatted" }
];